<template>
	<div class="box-add-poll">
		<div class="box-head">
			<div class="back-for-pc dash-color-skin">
	            <i class="fa fa-chevron-left" @click="togglePoll()"></i>
	        </div>
			<div class="topic-add-poll">{{ labels[nowLang].topicLabel }}</div>
		</div>
		<input type="text" class="dash-border-color-skin-light-30 dash-bg-color-skin-light-30 input-poll-name" :placeholder="labels[nowLang].topicPlaceHolder" v-model="topic">
		<div class="clearfix layout-checkbox">
			<input class="checkbox-style" type="checkbox" name="topicpoll" v-model="allowAddChoice">
			<div class="allow dash-color-skin">{{ labels[nowLang].allowLabel }}</div>
        </div>
        <div class="clearfix layout-checkbox">
			<input class="checkbox-style" type="checkbox" name="topicpoll" v-model="hasImage">
			<div class="allow dash-color-skin">{{ labels[nowLang].choiceimg }}</div>
        </div>
        <div class="clearfix box-choice">
          <template v-for="(choiceObj, index) in choices">
              <choice-poll :choiceObj="choiceObj" :index="index" :delChoice="delChoice" :hasImage="hasImage" :nowLang="nowLang" />
			    </template>		
        	<div class="input-poll-choice-add dash-border-color-skin dash-color-skin" v-on:click="addChoice()">{{ labels[nowLang].addChoiceLabel }}</div>
        </div>
        <div class="clearfix box-period">
        	<div class="period-label dash-color-skin">{{ labels[nowLang].period }}</div>
          <div class="input-poll-date">
            <hrms-datepicker  v-model="dtestrt"
                              v-validate="'required|date_format:DD/MM/YYYY'"
                              data-vv-value-path="inputDate"
                              name="dtestrt"
                              :has-error="errors.has('dtestrt')" />
            <div class="text-error" v-show="errors.has('dtestrt')">{{errors.first('dtestrt')}}</div>
          </div>
        	<div class="to dash-color-skin">-</div>
          <div class="input-poll-date">
            <hrms-datepicker  v-model="dteend"
                              v-validate="'required|date_format:DD/MM/YYYY'"
                              data-vv-value-path="inputDate"
                              name="dteend"
                              :has-error="errors.has('dteend')" />
            <div class="text-error" v-show="errors.has('dteend')">{{errors.first('dteend')}}</div>
          </div>
        </div>
        <div class="clearfix box-btn-make">
	        <div class="btn-make dash-bg-color-skin" v-on:click="addPoll()">
	        	{{ labels[nowLang].make }}
	        </div>
	    </div>


	</div>
</template>

<script>
import choicePoll from 'components/poll/choicePoll'
import _ from 'lodash'

var dtestrt = new Date()
var dteend = new Date(new Date().setDate(new Date().getDate() + 10))

export default{
  props: [ 'pcDisp', 'togglePoll', 'polls', 'nowLang', 'postPoll' ],
  data () {
    return {
      labels: {
        en: {
          topicLabel: 'Create Poll',
          topicPlaceHolder: 'Input poll title',
          allowLabel: 'Allow everyone to add more choices.',
          choiceimg: 'Include image in choice.',
          addChoiceLabel: 'Add new choice',
          period: 'Period of voting',
          make: 'Create'
        },
        th: {
          topicLabel: 'สร้างแบบสอบถาม',
          topicPlaceHolder: 'กรอกชื่อแบบสอบถาม',
          allowLabel: 'อนุญาติให้ทุกคนเพิ่มตัวเลือก',
          choiceimg: 'ตัวเลือกรูปภาพ',
          addChoiceLabel: 'เพิ่มตัวเลือก',
          period: 'กำหนดระยะเวลาโหวต',
          make: 'สร้าง'
        }
      },
      topic: '',
      allowAddChoice: false,
      hasImage: false,
      dtestrt: _.padStart(dtestrt.getDate(), 2, '0') + '/' + _.padStart((dtestrt.getMonth() + 1), 2, '0') + '/' + dtestrt.getFullYear(),
      dteend: _.padStart(dteend.getDate(), 2, '0') + '/' + _.padStart((dteend.getMonth() + 1), 2, '0') + '/' + dteend.getFullYear(),
      choices: []
    }
  },
  methods: {
    addChoice () {
      let numseq = this.choices.length
      this.choices.push({
        numseq: numseq + 1,
        image: '',
        text: '',
        number: 0,
        selected: 'N'
      })
    },
    delChoice (index) {
      this.choices.splice(index, 1)
    },
    addPoll () {
      this.$validator.validate().then(result => {
        if (result) {
          let pollParams = {
            topic: this.topic,
            hasImage: this.hasImage,
            choices: this.choices,
            addChoice: this.allowAddChoice,
            totalVote: 0,
            dtestrt: this.dtestrt,
            dteend: this.dteend
          }
          let pollChoices = []
          for (let choice of this.choices) {
            pollChoices.push({
              p_descchoice: choice.text,
              p_flguseradd: 'N',
              p_imagename: choice.image
            })
          }
          let sendParams = {
            p_dtestrt: this.dtestrt,
            p_dteend: this.dteend,
            p_desctitle: this.topic,
            p_flgaddchoice: this.allowAddChoice,
            p_flgimage: this.hasImage,
            p_flgmultichoice: 'N',
            p_choice: pollChoices
          }
          this.postChoice({ sendParams: sendParams, pollParams: pollParams })
          this.postPoll()
          this.choices = []
          this.togglePoll()
        }
      })
    }
  },
  components: {
    choicePoll
  }
}
</script>


// WEBPACK FOOTER //
// addpoll.vue?246f5d7c